/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { superAdminsControllerGetSuperAdminUsers } from '../fn/users-super-admins/super-admins-controller-get-super-admin-users';
import { SuperAdminsControllerGetSuperAdminUsers$Params } from '../fn/users-super-admins/super-admins-controller-get-super-admin-users';
import { superAdminsControllerRemoveAsSuperAdmin } from '../fn/users-super-admins/super-admins-controller-remove-as-super-admin';
import { SuperAdminsControllerRemoveAsSuperAdmin$Params } from '../fn/users-super-admins/super-admins-controller-remove-as-super-admin';
import { superAdminsControllerSetAsSuperAdmin } from '../fn/users-super-admins/super-admins-controller-set-as-super-admin';
import { SuperAdminsControllerSetAsSuperAdmin$Params } from '../fn/users-super-admins/super-admins-controller-set-as-super-admin';
import { UserDto } from '../models/user-dto';

@Injectable({ providedIn: 'root' })
export class PlatformUsersSuperAdminsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `superAdminsControllerGetSuperAdminUsers()` */
  static readonly SuperAdminsControllerGetSuperAdminUsersPath = '/api/v1/users/super-admins';

  /**
   * Get all super admin users.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superAdminsControllerGetSuperAdminUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  superAdminsControllerGetSuperAdminUsers$Response(params?: SuperAdminsControllerGetSuperAdminUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserDto>>> {
    const obs = superAdminsControllerGetSuperAdminUsers(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all super admin users.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superAdminsControllerGetSuperAdminUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superAdminsControllerGetSuperAdminUsers(params?: SuperAdminsControllerGetSuperAdminUsers$Params, context?: HttpContext): Observable<Array<UserDto>> {
    const resp = this.superAdminsControllerGetSuperAdminUsers$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<UserDto>>): Array<UserDto> => r.body)
    );
  }

  /** Path part for operation `superAdminsControllerSetAsSuperAdmin()` */
  static readonly SuperAdminsControllerSetAsSuperAdminPath = '/api/v1/users/super-admins';

  /**
   * Set a user as a super admin by user id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superAdminsControllerSetAsSuperAdmin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superAdminsControllerSetAsSuperAdmin$Response(params: SuperAdminsControllerSetAsSuperAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = superAdminsControllerSetAsSuperAdmin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Set a user as a super admin by user id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superAdminsControllerSetAsSuperAdmin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  superAdminsControllerSetAsSuperAdmin(params: SuperAdminsControllerSetAsSuperAdmin$Params, context?: HttpContext): Observable<void> {
    const resp = this.superAdminsControllerSetAsSuperAdmin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `superAdminsControllerRemoveAsSuperAdmin()` */
  static readonly SuperAdminsControllerRemoveAsSuperAdminPath = '/api/v1/users/super-admins/{id}';

  /**
   * Remove a user as a super admin.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `superAdminsControllerRemoveAsSuperAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  superAdminsControllerRemoveAsSuperAdmin$Response(params: SuperAdminsControllerRemoveAsSuperAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = superAdminsControllerRemoveAsSuperAdmin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Remove a user as a super admin.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `superAdminsControllerRemoveAsSuperAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  superAdminsControllerRemoveAsSuperAdmin(params: SuperAdminsControllerRemoveAsSuperAdmin$Params, context?: HttpContext): Observable<void> {
    const resp = this.superAdminsControllerRemoveAsSuperAdmin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
